export function initializeParallaxImage() {
    gsap.utils.toArray('.parallax').forEach(container => {
        const img = container.querySelector('img');
    
        const tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            scrub: true,
            pin: false,
        }
        });
    
        tl.fromTo(img, {
        yPercent: -10,
        ease: 'none'
        }, {
        yPercent: 10,
        ease: 'none'
        });
    });
}